import request from '../../axios';

const PatchLabRequirement = async (
  payload: ILabRequirementPayload,
  guid?: string,
) => {
  const newPayload = {
    sub_input: payload.sub_input?.guid,
    title: payload.title,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    only_massage_buyer: payload.only_massage_buyer || false,
    is_change_title: payload?.is_change_title,
    filter: 'requirement',
  };

  const response = await request.patch(`api/v2/store/advertisement/${guid}`, {
    ...newPayload,
  });

  return response.data;
};

export default PatchLabRequirement;
